export default function getFormattedPrice(price) {
  return `${price?.toFixed(2).toString().replace(/\./g, ',')} €`;
}
